import InquiryForm from '../InquiryForm';

function HomeContactFooter() {
  return (
    <footer
      className="mx-auto mb-10 grid w-[min(1120px,calc(100%-40px))] gap-8 rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-8 shadow-[0_22px_60px_rgba(24,50,40,0.08)] md:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]"
      id="kontakt"
    >
      <div>
        <p className="mb-3.5 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Kontakt</p>
        <h2 className="font-serif text-[clamp(2rem,4vw,3.2rem)] font-semibold leading-[1.02] text-[#163127]">
          Ta kontakt for tilgjengelighet og videre dialog.
        </h2>
        <p className="mt-4 max-w-[46ch] text-[1.05rem] leading-[1.7] text-[#355046]">
          Send oss en henvendelse via skjemaet, sa tar vi kontakt. Telefon og e-post legges til snart.
        </p>
      </div>
      <div>
        <InquiryForm />
      </div>
    </footer>
  );
}

export default HomeContactFooter;